import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const projectOverviewAPI = createApi({
    reducerPath: "projectOverviewAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getAllProjectOverviewList: builder.query({
            query: () => ({
                url:``,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllProjectDetails: builder.query({
            query: () => ({
                url:`/Project/GetAllProjectDetails`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getProjectOverviewMemberDetails: builder.query({
            query: (projectId) => ({
                url:`/Project/GetProjectOverviewMemberDetails?ProjectId=${projectId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getProjectOverviewStatusDetails: builder.query({
            query: (projectId) => ({
                url:`/Project/GetProjectOverviewStatusDetails?ProjectId=${projectId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getProjectOverviewMemberTaskDetails: builder.query({
            query: (projectId) => ({
                url:`/Project/GetProjectOverviewMemberTaskDetails?ProjectId=${projectId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        })


    })
})

export const{
    useLazyGetAllProjectOverviewListQuery,
    useLazyGetAllProjectDetailsQuery,
    useLazyGetProjectOverviewMemberDetailsQuery,
    useLazyGetProjectOverviewStatusDetailsQuery,
    useLazyGetProjectOverviewMemberTaskDetailsQuery
} = projectOverviewAPI;

export default projectOverviewAPI;